import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';

@Injectable()
export class ApplicationQueryParamsInterceptor implements HttpInterceptor {
  private configService = inject(ConfigService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const application = String(ConfigService.settings.app.id || '');

    const requestWithParams = request.clone({
      setParams: {
        origin: 'web',
        application
      }
    });

    return next.handle(requestWithParams);
  }
}
